module.exports = "65e0bc8332b18343d1e843adfb2e41c1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/temple-body.png
// module id = 47
// module chunks = 0